import { sendTeaCommEvent } from 'lib/tea-analyze'
import { MutableRefObject, useEffect } from 'react'

export default function useHandleBeforeLeave(
  processNow: MutableRefObject<number>,
  group_id: string
) {
  function sendPct() {
    const processPct = Math.min(Math.max(0, processNow.current), 1)
    sendTeaCommEvent('article_read_pct', {
      group_id,
      pct: (processPct * 100).toFixed(0),
    })
  }
  useEffect(() => {
    window.addEventListener('beforeunload', sendPct)
    return () => {
      sendPct()
      window.removeEventListener('beforeunload', sendPct)
    }
  }, [])
}
